export const setStoredTokens = (key = '', secret = '') => {
    key ? localStorage.setItem('key', key) : localStorage.removeItem('key')
    secret ? localStorage.setItem('secret', secret) : localStorage.removeItem('secret')
}